import { ActionTree } from "vuex";
import { RootState } from "@/store/types";
import API from "@/axios";
import { WebhookItem, FetchPaginatedPayload, WebhooksState, WebhookAttempt } from "../types";

const actions: ActionTree<WebhooksState, RootState> = {
  fetchWebhooks({ commit }) {
    return API.get("/settings/hooks?pageSize=20").then((response) => {
      const { data: results } = response;
      if (results.data) {
        commit("setWebhooks", results.data);
      }// response comes nested in data (data.data)
    });
  },
  fetchPaginatedWebhooks({ commit }, pageIndex: number) {
    return API.get(`/settings/hooks?pageSize=20&page=${pageIndex}`).then((response) => {
      // response comes nested in data (data.data)
      const { data: results } = response;
      if (results.data) {
        commit("setWebhooks", results.data);
      }
    });
  },
  fetchCurrentWebhook({ commit, state }, webhookId: string) {
    return new Promise(function (resolve, reject) {
      const currentWebhook: WebhookItem[] = state.webhooks.items.filter(
        (webhook) => webhook.id === webhookId
      );
      if (currentWebhook.length === 1) {
        commit("setCurrentWebhook", currentWebhook[0]);
        resolve(currentWebhook[0]);
      }
      reject("Webhook not found");
    });
  },
  fetchAttemptTotals({ commit }, webhookId: string) {
    return API.get(`/settings/hooks/${webhookId}/invocations?pageSize=6`).then(
      (response) => {
        if (response.data) {
          const results: WebhookAttempt = response.data.data;
          commit("setTotalAttempts", results.items.length);
          commit("setTotalSucceededAttempts", results.items.filter((result) => result.successful).length);
          commit("setTotalFailedAttempts", results.items.filter((result) => !result.successful).length);
        }
      }
    );
  },
  fetchPaginatedWebhookAttempts({ commit, state }, payload: FetchPaginatedPayload) {
    const { pageIndex, filterParam } = payload;
    return API.get(
      `/settings/hooks/${state.currentWebhook.id}/invocations?pageSize=6&pageIndex=${pageIndex}${filterParam}`
    ).then((response) => {
      if (response.data) {
        commit("setCurrentWebhookAttempts", response.data.data);
      }
    });
  },
  createWebhook(context, payload: WebhookItem) {
    const defaults = {
      contentType: "applicant/json",
      useContentType: true,
      enabled: true,
    };
    return API.post("/settings/hooks", {
      ...defaults,
      ...payload,
    });
  },
  updateWebhook(context, payload: WebhookItem) {
    return API.post(`/settings/hooks/${payload.id}`, {
      ...payload,
    });
  },
  deleteWebhook(context, webhookId: string) {
    return API.delete(`/settings/hooks/${webhookId}`);
  },
  viewAllAttempts({ commit }) {
    commit("setIsViewing", "all");
  },
  viewAllSuceededAttempts({ commit }) {
    commit("setIsViewing", "succeeded");
  },
  viewAllFailedAttempts({ commit }) {
    commit("setIsViewing", "failed");
  },
};

export default actions;
